module.exports = __webpack_public_path__ + "img/stop-watch.5dfe7df3.png";